var _defs, _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgButtonBell = function SvgButtonBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11.54 12.66",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#11141a;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "button_bell")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.16,8.19l-.73-.73V5.21A4.69,4.69,0,0,0,7.32.83,1.86,1.86,0,0,0,5.08.13a1.9,1.9,0,0,0-.86.7,4.66,4.66,0,0,0-3.1,4.38V7.46L.38,8.2A1.3,1.3,0,0,0,0,9.12v.55a1.34,1.34,0,0,0,.38.93,1.3,1.3,0,0,0,.93.38H3.47l0,.06a2.43,2.43,0,0,0,2.28,1.62h0A2.43,2.43,0,0,0,8.05,11l0-.06h2.16a1.3,1.3,0,0,0,.93-.38,1.34,1.34,0,0,0,.38-.93V9.12A1.32,1.32,0,0,0,11.16,8.19ZM10,9.48H1.51V9.2L2.62,8.08V5.21a3.17,3.17,0,0,1,2.32-3l.36-.1.14-.35a.36.36,0,0,1,.2-.2.3.3,0,0,1,.27,0,.35.35,0,0,1,.2.19l.13.35.37.1a3.16,3.16,0,0,1,2.31,3V8.08L10,9.2Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/button_bell.e5e3a471.svg";
export { ForwardRef as ReactComponent };